import React, { useState, useEffect } from "react";
import { Paginator } from "../../layout/Paginator/Paginator";
import { connect } from "react-redux";
import { showSpinner, hideSpinner } from "../../../store/actions/loading";
import { Search } from "../../layout/Table/Search";
import { TableComponent } from "./table/Table";
import { getUsers as getUsersApi } from "../../../api/clients/users";
import { ACL, USER_STATUSES } from '../../../config/constants';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { ListToolbar } from "../../layout/Workspace";

let oneTimeCall = false;
function ClientsTableComponent(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [users, setUsers] = useState(null);
  const [meta, setMeta] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState( 10 );

  useEffect( () => {
    getUsers( 1, sortField, sortDirection, searchText );

    return () => {
      store.dispatch(hideNotification());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  /**
   * Get client users
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getUsers = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.CLIENT.USERS.LIST.hasAccess() || oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;

    getUsersApi({
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
      },
      hideNotification: hideNotification,
    }).then((response) => {
      if (!response || !response.data) {
        return;
      }

      response.data.forEach(user => {
        if ( ! user?.email_verified_at && user?.status === USER_STATUSES.ACTIVE ) {
          user.status = USER_STATUSES.INACTIVE;
        }
      });

      setUsers(response.data);
      setMeta(response.meta);
      props.hideSpinner();
    }).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getUsers(meta.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <div className="clients-list-layout">
      <ListToolbar
        className="clients-list-toolbar"
        search={ACL.CLIENT.USERS.SEARCH.hasAccess() ? (
          <Search
            permissions
            search={(searchText) => {
              setSearchText(searchText);
              getUsers(1, null, null, searchText, true);
            }}
            id="client-users"
          />
        ) : null}
        settings={(
          <AutoRefreshTable
            id="client-users"
            getData={getUsers}
            sortDirection={sortDirection}
            sortField={sortField}
            searchText={searchText}
          />
        )}
      />
      <div className="clients-list-table">
        <TableComponent
          applySort={(sortField) => applySort(sortField)}
          users={users}
          actionCallback={(useState) => {
            if (useState) {
              getUsers(meta.current_page, sortField, sortDirection, searchText);
            } else {
              getUsers();
            }
          }}
        />
      </div>
      <div className="clients-list-pagination">
        <Paginator
          meta={meta}
          settings={(
            <RowsPerPage
              changeRowsPerPage={(rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
              }}
              id="client-users"
            />
          )}
          changePage={(page) =>
            getUsers(page, sortField, sortDirection, searchText, true)
          }
        />
      </div>
    </div>
  );
}

ClientsTableComponent.defaultProps = {};

const ClientsTable = connect(null, {
  showSpinner,
  hideSpinner,
})(ClientsTableComponent);

export { ClientsTable, ClientsTableComponent };
